/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:06:21
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-28 09:40:22
 */

import { SetPositionRecord } from './history/record.js'
import { GraphElement } from './graph-element.js'
import { pointInRect } from './utils/index.js'
import {
  BusElement,
  ELinkElement,
  EBlockElement,
  PCCElement,
  ESSElement,
  PVElement,
  PCSElement,
  LoadElement,
  TransformerElement,
  SquareElement,
  BreakerElement,
  GroundElement,
  RectElement,
  CircleElement,
  TextElement,
  ChargePileElement,
  ChargeStationElement,
  MeterElement,
  SwitchElement,
  FoldLineElement,
} from './element/index.js'
import Konva from 'konva'

export const Constructors = {
  bus: BusElement,
  eLink: ELinkElement,
  eBlock: EBlockElement,
  pcc: PCCElement,
  pcs: PCSElement,
  ess: ESSElement,
  pv: PVElement,
  payload: LoadElement,
  transformer: TransformerElement,
  square: SquareElement,
  breaker: BreakerElement,
  ground: GroundElement,
  rect: RectElement,
  circle: CircleElement,
  text: TextElement,
  chargePile: ChargePileElement,
  chargeStation: ChargeStationElement,
  meter: MeterElement,
  switch: SwitchElement,
  foldLine: FoldLineElement,
}


export class Handler {

  /**
   * @param {import('./topology').Topology} topology
   */
  constructor(topology) {
    this.topology = topology
    const { storage, painter, history } = topology
    this.storage = storage
    this.painter = painter
    this.history = history
    this.setup()
  }

  get stage() {
    return this.storage.stage
  }

  setup() {
    if (this.topology.editor) {
      this.eventHandler()
    } else {
      // 非编辑模式下，仅启用画布移动功能
      this.handlerMoveCanvasReadOnly()
    }
    // this.painter.paint()
  }

  eventHandler() {
    this.handlerDnd()
    this.handlerMoveElement()
    this.handlerKeyBoardEvent()
    this.handlerDrawLine()
    this.handlerSelection()
  }

  /**
   * 拖拽时创建元素
   */
  handlerDnd() {
    const container = this.topology.dom.graphElem
    let etLib = document.querySelector('.et-lib')
    for (const child of etLib.children) {
      child.addEventListener('dragstart', (event) => {
        let type = event.target.closest('figure').dataset.type
        let name = event.target.closest('figure').dataset.name
        event.dataTransfer.setData("type", type)
        event.dataTransfer.setData("name", name)
      })
    }

    container.addEventListener('dragover', (event) => {
      event.preventDefault()
    })


    container.addEventListener('drop', (event) => {
      event.preventDefault()
      const type = event.dataTransfer.getData("type")
      const text = event.dataTransfer.getData("name")

      this.topology.addElementByType(type, text, event.offsetX, event.offsetY)
    })
  }

  /**
   * 处理元素拖动
   */
  handlerMoveElement() {
    const { stage, painter } = this
    const oldPos = { x: 0, y: 0 }

    stage.on('dragstart', (event) => {
      // 记录起始绝对坐标（撤销/重做 和 shift方向锁定都依赖它）
      let pos = event.target.absolutePosition()
      oldPos.x = pos.x
      oldPos.y = pos.y
    })

    // 元素移动时 更新连线位置
    stage.on('dragmove', (event) => {

      // 按住shift时，非母线元素只能垂直移动
      if (event.evt.shiftKey) {
        const pos = event.target.absolutePosition()
        const graphElement = event.target.__ge

        // 非母线元素
        if (graphElement instanceof GraphElement && !(graphElement instanceof BusElement)) {
          const incomeEdges = graphElement.getIncomingEdges()
          const edge = incomeEdges[0]
          if (edge) {
            const x = edge.source.port.absolutePosition().x - (graphElement.width / 2)
            event.target.absolutePosition({ x: x, y: pos.y })
          }
        }
      }

      painter.update()
      painter.showReferenceLine(event.target)
    })

    stage.on('dragend', (event) => {
      let newPos = event.target.absolutePosition()
      painter.hideReferenceLine()
      this.history.push(new SetPositionRecord(this, event.target, newPos, oldPos))
    })
  }

  /**
   * 处理键盘事件
   */
  handlerKeyBoardEvent() {
    const graphElem = this.topology.dom.graphElem

    graphElem.addEventListener('mousedown', () => {
      graphElem.focus()
    })

    graphElem.addEventListener('keyup', (event) => {
      if (event.key == 'Delete' || event.key == 'Backspace') {
        this.storage.removeSelectedElement()
        this.painter.paint()
      }
    })

    graphElem.addEventListener('keyup', (event) => {
      if (event.key == 'z' && event.ctrlKey) {
        this.history.undo()
        this.painter.paint()
      }
    })

    graphElem.addEventListener('keyup', (event) => {
      if (event.key == 'Z' && event.ctrlKey && event.shiftKey) {
        this.history.redo()
        this.painter.paint()
      }
    })

    graphElem.addEventListener('keyup', async (event) => {
      // console.log('event', event);      
      if (event.key == 'c' && event.ctrlKey) {
        // 复制当前元素
        const copied = this.storage.selectedElement.copyJSON()
        console.log('Ctrl + C', copied);
        sessionStorage.setItem('topo:copiedElement', JSON.stringify(copied))
      }
      if (event.key == 'v' && event.ctrlKey) {
        // 粘贴当前元素
        try {
          const copiedElement = JSON.parse(sessionStorage.getItem('topo:copiedElement'))
          console.log('Ctrl + V', copiedElement);
          // 粘贴时，粘贴到鼠标所在位置
          const pos = this.stage.getPointerPosition()
          copiedElement.attrs.x = pos.x - this.stage.x()
          copiedElement.attrs.y = pos.y - this.stage.y()
          
          const Ctor = Constructors[copiedElement.type] || GraphElement          
          await Ctor.fromJSON(this.topology, copiedElement)
        } catch (error) {
          console.error('粘贴失败', error);
        }
      }
    })

    window.addEventListener('keydown', this.handlerArrowEvent.bind(this))
    window.addEventListener('keyup', () => this.painter.hideReferenceLine())
  }


  /**
   * 处理方向键
   * @param {*} event
   */
  handlerArrowEvent(event) {
    const key = event.key

    // 仅处理方向键
    if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key)) {
      return
    }

    const tr = this.storage.layer.findOne('#el-tr')

    // 每次移动的步长，按住shift时，移动10个像素
    let step = 1
    if (event.shiftKey) {
      step = 10
    }

    // 计算本次移动的偏移量
    let dx = 0
    let dy = 0
    if (key === 'ArrowUp') {
      dy = -step
    } else if (key === 'ArrowDown') {
      dy = step
    } else if (key === 'ArrowLeft') {
      dx = -step
    } else if (key === 'ArrowRight') {
      dx = step
    }

    // 普通元件：通过 #el-tr 变换组移动其分组节点
    if (tr) {
      tr.nodes().forEach((node) => {
        node.x(node.x() + dx)
        node.y(node.y() + dy)
      })
    }

    // 母线：使用独立的 #bus-tr 变换组，不在 #el-tr 中，需单独移动其分组
    const selected = this.storage.selectedElement
    if (selected instanceof BusElement) {
      selected.g.x(selected.g.x() + dx)
      selected.g.y(selected.g.y() + dy)
    }

    // 更新画布
    this.painter.update()
    this.storage.layer.draw()
    this.painter.showReferenceLine(tr)
  }



  /**
   * 处理鼠标框选（含空格+左键画布平移）
   */
  handlerSelection() {
    const { storage, topology } = this
    const { stage, layer } = storage
    const graphElem = topology.dom.graphElem

    let spaceDown = false

    graphElem.addEventListener('keydown', (event) => {
      if (event.key == ' ') {
        event.preventDefault()
        spaceDown = true
        graphElem.style.cursor = 'grab'
      }
    })

    graphElem.addEventListener('keyup', (event) => {
      if (event.key == ' ') {
        spaceDown = false
        graphElem.style.cursor = 'default'
      }
    })

    let selectionRectangle = new Konva.Rect({
      fill: 'rgba(0,120,215,0.1)',
      stroke: 'rgba(0,120,215,1)',
      visible: false,
      dash: [4, 2]
    })

    let lastPos = { x: 0, y: 0 }
    let isCanvasPanning = false
    let panLastPos = { x: 0, y: 0 }
    let panStagePos = { x: 0, y: 0 }

    layer.add(selectionRectangle)

    stage.on('contextmenu', (event) => {
      event.evt.preventDefault()
    })

    stage.on('mousedown', (event) => {
      event.evt.preventDefault()
      const isLeft = event.evt.button === 0

      // 空格+左键：平移画布（优先级最高，不区分目标）
      if (spaceDown && isLeft) {
        isCanvasPanning = true
        let pos = stage.getPointerPosition()
        panLastPos.x = pos.x
        panLastPos.y = pos.y
        panStagePos.x = stage.x()
        panStagePos.y = stage.y()
        graphElem.style.cursor = 'grabbing'
        return
      }

      // 只有鼠标左键才会选择
      if (!isLeft) {
        return
      }

      if (event.target !== stage) {
        return
      }

      let pos = stage.getPointerPosition()
      lastPos.x = pos.x - stage.x()
      lastPos.y = pos.y - stage.y()

      selectionRectangle.visible(true)
      selectionRectangle.width(0)
      selectionRectangle.height(0)
    })


    stage.on('mousemove', (e) => {
      if (isCanvasPanning) {
        let pos = stage.getPointerPosition()
        stage.position({
          x: panStagePos.x + pos.x - panLastPos.x,
          y: panStagePos.y + pos.y - panLastPos.y,
        })
        return
      }

      if (!selectionRectangle.visible()) {
        return
      }

      let pos = stage.getPointerPosition()
      // let stagePos = { x: stage.x(), y: stage.y() }
      // pos.x -= stagePos.x
      // pos.y -= stagePos.y

      selectionRectangle.setAttrs({
        x: Math.min(lastPos.x, pos.x - stage.x()),
        y: Math.min(lastPos.y, pos.y - stage.y()),
        width: Math.abs(pos.x - lastPos.x - stage.x()),
        height: Math.abs(pos.y - lastPos.y - stage.y()),
      })

      e.evt.preventDefault()
    })



    stage.on('mouseup', (e) => {
      if (isCanvasPanning) {
        isCanvasPanning = false
        graphElem.style.cursor = spaceDown ? 'grab' : 'default'
        return
      }

      if (!selectionRectangle.visible()) {
        return
      }
      e.evt.preventDefault()

      setTimeout(() => {
        selectionRectangle.visible(false)
      })
      let tr = layer.findOne('#el-tr')
      let shapes = storage.layer.getChildren().filter(child => {
        return child.nodeType == 'Group' && child.className != 'Transformer'
      })


      var box = selectionRectangle.getClientRect()
      var selected = shapes.filter((shape) =>
        Konva.Util.haveIntersection(box, shape.getClientRect())
      )

      storage.deselect()
      this.storage.selectedList = selected.map(g => g.__ge)
      tr && tr.nodes(selected)
    })


    stage.on('click', (event) => {
      let tr = layer.findOne('#el-tr')
      if (selectionRectangle.visible()) {
        return
      }
      // 点击空白区域时清空已选择的元素
      if (event.target === stage) {
        tr && tr.nodes([])
        this.storage.selectedList = []
        return
      }
    })


  }


  /**
   * 非编辑模式下的画布移动（只读模式）
   * 支持鼠标左键和右键拖动画布，但不允许移动元素
   */
  handlerMoveCanvasReadOnly() {
    const { stage } = this

    let lastPos = { x: 0, y: 0 }
    let stagePos = { x: 0, y: 0 }
    let isDragging = false

    // 鼠标按下时记录初始位置
    stage.on('mousedown', (event) => {
      // 支持左键(0)和右键(2)拖动
      const button = event.evt.button
      if (button === 0 || button === 2) {
        // 只有点击画布空白区域时才能拖动
        if (event.target === stage) {
          isDragging = true
          const pos = stage.getPointerPosition()
          lastPos.x = pos.x
          lastPos.y = pos.y
          stagePos.x = stage.x()
          stagePos.y = stage.y()

          // 设置鼠标样式为抽取手型
          stage.container().style.cursor = 'grabbing'
        }
      }
    })

    // 鼠标移动时更新画布位置
    stage.on('mousemove', (event) => {
      if (isDragging) {
        const pos = stage.getPointerPosition()
        const deltaX = pos.x - lastPos.x
        const deltaY = pos.y - lastPos.y

        stage.position({
          x: stagePos.x + deltaX,
          y: stagePos.y + deltaY,
        })
      }
    })

    // 鼠标释放时结束拖动
    stage.on('mouseup', () => {
      if (isDragging) {
        isDragging = false
        stage.container().style.cursor = 'default'
      }
    })

    // 鼠标离开画布时也结束拖动
    stage.on('mouseleave', () => {
      if (isDragging) {
        isDragging = false
        stage.container().style.cursor = 'default'
      }
    })

    // 禁止右键菜单
    stage.on('contextmenu', (event) => {
      event.evt.preventDefault()
    })
  }



  /**
   * 处理元素之间的连线绘制
   */
  handlerDrawLine() {
    const { storage, painter } = this
    const { stage } = storage

    // 是否开始绘制
    let startDrawLine = false
    // 源元素
    let sourceGE = null
    // 源元素端口位置
    let lastPos = { x: 0, y: 0 }
    // 目标端口元素
    let lastPort = null
    // 当前正在绘制的线条
    let drawingLine = null

    const hoverDrawingLine = () => {
      drawingLine && drawingLine.stroke('rgb(0, 179, 0)')
      storage.layerLines.batchDraw()
    }

    const normalDrawingLine = () => {
      drawingLine && drawingLine.stroke('rgb(214, 0, 0)')
      storage.layerLines.batchDraw()
    }

    const resetState = () => {
      drawingLine && drawingLine.remove()
      startDrawLine = false
      sourceGE = null
      drawingLine = null
    }

    stage.on('start-drawline', (event) => {
      log('start-drawline', event)
      startDrawLine = true
      lastPos.x = event.pos.x
      lastPos.y = event.pos.y
      //
      sourceGE = event.sourceGraphElement
      lastPort = event.port
    })


    stage.on('mousemove', (e) => {
      // log('stage mousemove')
      const pos = stage.getPointerPosition()
      if (startDrawLine) {
        if (!drawingLine) {
          drawingLine = new Konva.Line({
            x: 0,
            y: 0,
            stroke: 'red',
            strokeWidth: 2,
            dash: [4, 4],
          })
          storage.layerLines.add(drawingLine)
        }

        // 检测连线与除自身元素组之外的其他元素端点是否相交
        let children = storage.layer.getChildren().filter(child => {
          return child.nodeType == 'Group' && child != sourceGE.g
        })
        for (const child of children) {
          if (child.__ge instanceof GraphElement) {
            let rect = child.__ge.keyShape.getClientRect()
            if (pointInRect(rect, pos.x, pos.y)) {
              if (child.__ge instanceof BusElement && sourceGE instanceof BusElement) {
                normalDrawingLine()
              } else {
                hoverDrawingLine()
              }
              break
            } else {
              normalDrawingLine()
            }
          }
        }

        // 连线终点（图层局部坐标）
        let endX = pos.x - stage.x()
        let endY = pos.y - stage.y()

        // 按住shift时，绘制的连线只能水平或垂直：按位移较大的轴锁定另一轴
        if (e.evt.shiftKey) {
          let dx = endX - lastPos.x
          let dy = endY - lastPos.y
          if (Math.abs(dx) >= Math.abs(dy)) {
            endY = lastPos.y
          } else {
            endX = lastPos.x
          }
        }

        drawingLine.points([lastPos.x, lastPos.y, endX, endY])
      }
    })

    stage.on('mouseup', () => {
      const pos = stage.getPointerPosition()
      if (sourceGE) {
        let children = storage.layer.getChildren().filter(child => {
          return child.nodeType == 'Group' && child != sourceGE.g
        })
        let hasIntersect = false
        for (const child of children) {
          const ge = child.__ge
          if (ge instanceof GraphElement) {
            let rect = ge.keyShape.getClientRect()
            // if (sourceGE instanceof BusElement) {
            //   if (ge instanceof BusElement) {
            //     break
            //   }
            //   // if (this.storage.graph.hasEdge(sourceGE)) {
            //   //   break
            //   // }
            // }

            hasIntersect = pointInRect(rect, pos.x, pos.y)
            if (hasIntersect) {
              log('inerset', [pos.x, pos.y])
              let src = {
                node: sourceGE,
                port: lastPort
              }
              // 目标是母线时 在母线上方新增一个端口
              let target = {
                node: ge,
                // pos 为 getPointerPosition() 的绝对坐标，addUpPort 需要图层局部坐标，减去画布平移量避免端口跑偏
                port: (ge instanceof BusElement) ? ge.addUpPort(pos.x - stage.x()) : ge.ports.portUp,
              }
              // 新增一条从源元素到目标元素的边
              this.storage.graph.addEdge(src, target)
              this.painter.paint()
              break
            }
          }
        }
        // 源元素是母线节点 且绘制结束时无目标元素 则清除端点
        if (!hasIntersect && (sourceGE instanceof BusElement)) {
          sourceGE.removePort(lastPort)
        }
        sourceGE.g.draggable(true)
      }
      //
      resetState()
    })
  }

}
